module.exports = __webpack_public_path__ + "static/media/94.f5f746be.png";